// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"9e302b81","156":"fbe8f69c","185":"40d722f8","194":"ea654e3f","200":"14cf671a","241":"a738f188","565":"7cccd661","616":"1c5db4aa","654":"293b3567","734":"7b9a721b","768":"f1dce226"}[chunkId] + ".chunk.js";
};